import { c as _c } from "react/compiler-runtime";
import { Card, Stack, Typography } from '@mui/material';
import type { BackupPolicyType, Condition, ResourceType } from '@repo/api-gw-sdk';
import { ConditionViewer } from '@/components/conditions/ConditionViewer';
import { isAnAllCondition, isEmptyCondition, type FilterProperty } from '@/types/advanceFilter';
import { DynamicResourcesAllExcluded, DynamicResourcesAllIncluded } from '../../app/(dashboard)/settings/backup-policies/backup-scopes/[tab]/dynamicResourcesEmptyState';
export type ResourcesScopeType = 'allIncluded' | 'allExcluded' | 'useConditions';
export const getResourcesScopeType = (condition: Condition | undefined, fallback: ResourcesScopeType): ResourcesScopeType => {
  if (condition && isAnAllCondition(condition)) {
    if (condition.value?.[0] === 'true') {
      return 'allIncluded';
    }
    if (condition.value?.[0] === 'false') {
      return 'allExcluded';
    }
  }
  if (!condition || isEmptyCondition(condition)) {
    return fallback;
  }
  return 'useConditions';
};
interface ResourceSelectionDynamicViewerProps {
  condition?: Condition;
  conditionTitle: React.ReactNode;
  resourcesScopeType: ResourcesScopeType;
  allExcludedDescription: string;
  allIncludedDescription: string;
  supportProperties: FilterProperty[];
  selectedResourceTypes?: ResourceType[];
  policyType?: BackupPolicyType;
}
export const ResourceSelectionDynamicViewer = t0 => {
  const $ = _c(10);
  const {
    condition,
    conditionTitle,
    resourcesScopeType,
    allExcludedDescription,
    allIncludedDescription,
    supportProperties,
    selectedResourceTypes,
    policyType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "auto",
      border: "1px solid var(--mui-palette-divider)",
      padding: "24px",
      backgroundColor: "transparent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== allExcludedDescription || $[2] !== allIncludedDescription || $[3] !== condition || $[4] !== conditionTitle || $[5] !== policyType || $[6] !== resourcesScopeType || $[7] !== selectedResourceTypes || $[8] !== supportProperties) {
    t2 = <Card sx={t1}>{resourcesScopeType === "useConditions" && condition ? <Stack sx={{
        gap: "16px"
      }}>{typeof conditionTitle === "string" ? <Typography variant="subtitle1">{conditionTitle}</Typography> : conditionTitle}<ConditionViewer condition={condition} supportProperties={supportProperties} /></Stack> : <>{resourcesScopeType === "allExcluded" ? <DynamicResourcesAllExcluded description={allExcludedDescription} size="small" /> : <DynamicResourcesAllIncluded description={allIncludedDescription} size="small" selectedResourceTypes={selectedResourceTypes} policyType={policyType} />}</>}</Card>;
    $[1] = allExcludedDescription;
    $[2] = allIncludedDescription;
    $[3] = condition;
    $[4] = conditionTitle;
    $[5] = policyType;
    $[6] = resourcesScopeType;
    $[7] = selectedResourceTypes;
    $[8] = supportProperties;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};